import { metaAccount } from '@/router/meta-config'
const permissionKey = 'GUIDE'

export default [
  {
    path: '/guides',
    name: 'page-guides',
    component: () => import('@/pages/guides'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/guide/new',
    name: 'page-guide-new',
    component: () => import('@/pages/guide'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/guide/:id',
    name: 'page-guide',
    component: () => import('@/pages/guide'),
    props: (route) => ({ id: route.params.id }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
